import React, {InputHTMLAttributes} from "react";

interface Props  extends InputHTMLAttributes<HTMLInputElement>{
    label:string;
    name: string; 
    value:string | undefined; 
    error: boolean;    
    handleChange:any;
    errorText?: string;    
    disabled?: boolean;
    maxLength?: number;
}

const Input: React.FC<Props> = ({label, name, value, error, handleChange, errorText, disabled, maxLength }) => {
  //const { label, name, value, error, handleChange, errorText, props } = props;

  return (
    <>
    <div
      className="inline"
      style={{
        width: "50%",
        marginBottom: "2px",
        color: error ? "red" : "black",
      }}
    >
      {label}
    </div>
    <div className="inline" style={{ width: "50%", marginBottom: "2px" }}>
      <input
        style={{ width: "100%" }}
        name={name}
        type="text"
        value={value}
        onChange={handleChange}
        disabled = {disabled}
        maxLength = {maxLength}
      /> {errorText}
    </div>
  </>
  );
};

export default Input;
